import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { Store } from '@ngrx/store';
import type { JwtServiceInterface, JwtTokens } from '@wizbii-utils/angular/jwt';
import { jwtDelete, jwtSet, jwtTokens } from '@wizbii-utils/angular/stores';
import { AuthenticationWebservice } from '@wizbii-utils/angular/webservices';
import { LocaleEnum } from '@wizbii/utils/models';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class JwtService implements JwtServiceInterface {
  blacklistRoutes: (string | RegExp)[];
  readonly #store = inject(Store);
  readonly #authService = inject(AuthenticationWebservice);

  constructor() {
    this.blacklistRoutes = [
      'https://storage.googleapis.com',
      environment.api.strapi,
      new RegExp(`${environment.api.authentication}(?!(/v1/user).*(/email|password|overview))`, 'i'),
      new RegExp(`${environment.api.account}/v2/country/${Object.values(LocaleEnum).join('|')}`),
    ];
  }

  getTokens(): Observable<any> {
    return this.#store.select(jwtTokens).pipe(map((jwtState) => (!jwtState?.token ? null : jwtState)));
  }

  logout(): void {
    this.#store.dispatch(jwtDelete());
    window.open(`${environment.urls.account.logout}${window.location.origin}`, '_self');
  }

  refreshToken(tokens: JwtTokens): Observable<JwtTokens> {
    return this.#authService.refreshTokenV2(tokens, environment.applicationId).pipe(
      map((newTokens) => {
        this.#store.dispatch(jwtSet({ jwtTokens: newTokens }));
        return newTokens;
      })
    );
  }

  saveLocalTokens(jwtTokens: JwtTokens): void {
    this.#store.dispatch(jwtSet({ jwtTokens }));
  }
}
